export const displayName = 'Mortgage Maker';
export const name = 'mortgage-maker';

export const pageSize = 15;
export const paginationSize = 6;
export const getUserDelay = 2000;

export const userLifetime = 14400000;
export const USER_FREE_TRIAL_DAYS = 30;
export const MAX_FILE_SIZE = 35 * 1024 * 1024; // ~35 MB

export const alertDelaySuccess = 2000;
export const alertDelayWarning = 5000;
export const alertDelayError = 10000;

export const alertDelayConfirmationEmail = 60000;
export const alertDelayChangeEmail = 60000;
export const alertDelayNewPassword = 60000;
export const alertDelayForgotPassword = 60000;
export const alertDelayResendEmail = 60000;
